import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import Snackbar from "../../../../Snackbar";
import {Plus, X,} from 'lucide-react';
import RichTextEditor from "../../../UI/RichTextEditor";
import { createNewRichContent } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import RichContentCard from "./RichContentCard";
import UploaderAllCM from "../Uploader/UploaderAllCM";
import ImageWithFallback from "../../../UI/ImageFallBack";


import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import AreYouSurePopUp from "../ContentPopUp/AreYouSurePopUp";
import UniversalVideoPlayer from "../../CreateWebsite/VideoPlayer/UniversalVideoPlayerWebUI";
import PDFReaderCM from "../../../UI/PDFReaderCM";
import SafeHtmlRenderer from "./SafeHtmlRenderer";
  
const QuestionRichContent= ({postParentId})=>{ 
    const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
        const [deleteTopicPopUp, setDeleteTopicPopUp] = useState(false);
        const [contentId, setContentId] = useState("");
         
      ;const handleDeleteRichContent=(contentId)=>{
             
             
             
             setLoader({status:true});
             
               const apiData = dispatch(createNewRichContent({contentId:contentId,
                           postParent:postParentId,userEmail:user_email?user_email:"",menuOrder:itemArr?.length+1,
                           currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
                           editType:"delete",appToken:AppToken,appId:appId}
                           ));
               /* get response as Promise   */
               apiData.then(response => {
                 if(response){     
                   setFireStatus(true)
               setTimeout(()=>{
                  setFireStatus(false)
                    
                 },100)
                   
                
                if(response?.logout){
                
                 setResponseMessage("You are Logged Out!!!");
                   
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                 setTimeout(()=>{
                   dispatch({type:"LOGOUT"});
             
                 },3000)
                 
               }
             /* resetting Login input Fields */
             
                 }else{
                   setResponseMessage("Something Went Wrong...");
                   
                   setSnackbarColor("#958FDA");
                
                    
               setLoader({status:false});
               
               setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
                
                  
               },3000)    }
             
               }).catch(error => {
              
                 //popup of error Info
                 setResponseMessage("Something Went Wrong...");
                   
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                 console.error(error);
               });
              
               }
          const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
        const [isLoaded, setIsLoaded] = useState(false);
        const [hasError, setHasError] = useState(false);
        
           
                
                     
        return (
         
            <img
      
            
              src={ src}
              alt=""
             style={
                   {
                     
            top: 0,
            left: 0,
            width: `${width}%`,
           
            objectFit: "cover", }}
             className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
            />
          
        );
      };
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
   

       const [content, setContent] = useState('');
       const [topicShow, setTopicShow] = useState('RichText');
       const [titleText, setTitleText] = useState('');
   const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
     const [currentTopic, setCurrentTopic] = useState({});
     const [openUploaderPopUp, setOpenUploaderPopUp] = useState(false);
     const [currentFileType, setCurrentFileType] = useState({});
      
     const [itemArr, setItemArr] = useState([]);
      const [loader , setLoader] =useState({status:false});
     const[fireStatus,setFireStatus] =useState(false);
       useEffect(()=>{fireGetContentsByQuestionId()},[fireStatus])
         
  const fireGetContentsByQuestionId=()=>{
       setItemArrLoading([{},{},{},{}])
        setLoader({status:true});
        //  alert(postParentId)
          const apiData = dispatch(createNewRichContent({contentType:"instruction",
            postParent:postParentId,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
            editType:"getAll",appToken:AppToken,appId:appId}
            ));
          /* get response as Promise   */
          apiData.then(response => {
            if(response){   console.log(response)
              if(response?.contents){
                setItemArrLoading([])
            setResponseMessage(response?.message);
            setSnackbarColor("rgba(144, 202, 249,1)");
         setItemArr(response?.contents);
         setTitleText(response?.contents[1]?.titleText)
           }else{
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
           }
              
           
           if(response?.logout){
           
            setResponseMessage("You are Logged Out!!!");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            setTimeout(()=>{
              dispatch({type:"LOGOUT"});
        
            },3000)
            
          }
        /* resetting Login input Fields */
        
            }else{
              setResponseMessage("Something Went Wrong...");
              
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)    }
        
          }).catch(error => {
         
            //popup of error Info
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            console.error(error);
          });
         
          }
          const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
  
  
 
     return(<>
             
    <div style={{zIndex:99,}} > 
        {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 

     
   
                <div  className=" " >

  {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.id}  style={{}}  >

            <div style={{padding:"10px"}}>   
   {item?.mimeType==""?  <SafeHtmlRenderer
      html={item?.contentFormatedText}
      className="content"
    />:
   item?.mimeType=="image"?<div style={{position:"relative",padding:"10px"}}><style>{`.img-btns-outer { position: absolute;
          top: 10px;z-index:999;
          right: 10px; display:flex;justify-content:right;gap:10px}
        .img-btn {
         
          background: rgba(144, 202, 249,1);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          padding: 5px 10px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .img-btn:hover {
          background: rgba(144, 202, 249,0.81);
        }`}</style>
   
   
   <ImageFallFB src={item?.image_presigned_url} 
    border={{}}
                      width={ 100
                      }
                      aspectRatio={1}
                      borderRadius={ {}
                      }/>
                      
                      
                      </div>:item?.mimeType=="video"?<div style={{position:"relative",padding:"10px",marginTop:"50px"}}><style>{`.vid-btns-outer { position: absolute;
          top: -50px;z-index:999;
          right: 10px; display:flex;justify-content:right;gap:10px}
        .vid-btn {
         
          background: rgba(144, 202, 249,1);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          padding: 5px 10px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .vid-btn:hover {
          background: rgba(144, 202, 249,0.81);
        }`}</style>
  <UniversalVideoPlayer  videoSettings={{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"mp4URL",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           
                            videoThumbnail:{
                                src:"",hideThumbnail:true,
                                            },
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:50,resolution:"%"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }} videoUrl={item?.video_presigned_url} minHeight={450} maxHeight={450}/>
                                      </div>:item?.mimeType=="pdf"?<div style={{position:"relative",padding:"10px",marginTop:"50px"}}><style>{`.vid-btns-outer { position: absolute;
          top: -50px;z-index:999;
          right: 10px; display:flex;justify-content:right;gap:10px}
        .vid-btn {
         
          background: rgba(144, 202, 249,1);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          padding: 5px 10px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .vid-btn:hover {
          background: rgba(144, 202, 249,0.81);
        }`}</style>
   

 <PDFReaderCM fileUrl={item?.pdf_presigned_url} />

                                    </div>:""}
     </div> </div>
  )):
  <></>:""}

           
   
     
      </div>
     

       </div>  

  
      
                                    
     </>)  
   }
   export default QuestionRichContent;